var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell',{attrs:{"title":_vm.title,"icon":_vm.icon,"is-link":"","arrow-direction":_vm.showCtn ? 'up' :'down'},on:{"click":function($event){_vm.showCtn = !_vm.showCtn}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCtn),expression:"showCtn"}],class:_vm.ctnClass || 'pad-lft-20'},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }